import { parsePhoneNumber } from 'libphonenumber-js'
import * as Yup from 'yup'

Yup.addMethod(Yup.string, 'validatePhone', function (errorMessage) {
  return this.test(`test-phone`, errorMessage, function (value) {
    const { path, createError } = this

    if (!value || value.length < 10) {
      return createError({ path, message: errorMessage })
    }

    try {
      const parsedPhoneNumber = parsePhoneNumber(value, 'US')

      return (
        !!parsedPhoneNumber?.formatInternational() || createError({ path, message: errorMessage })
      )
    } catch (err) {
      return createError({ path, message: errorMessage })
    }
  })
})

export const CustomerOnboardingTSASchema = Yup.object().shape({
  isRegisteredAgent: Yup.string().required('This field is required'),
})

export const CustomerOnboardingRegisteredAgentTSASchema = Yup.object().shape({
  isRegisteredAgent: Yup.string().required('This field is required'),
  iacNumber: Yup.string().required('This field is required'),
  dateOfLastCertification: Yup.string().required('This field is required'),
  agentName: Yup.string().required('This field is required'),
  coordinatorName: Yup.string().required('This field is required'),
  coordinatorPhoneNumber: Yup.string()
    // @ts-ignore
    .validatePhone('Phone number is invalid')
    .required('This field is required'),
  coordinatorEmail: Yup.string().email('Email is invalid').required('This field is required'),
})

export const CustomerOnboardingNotRegisteredAgentTSASchema = Yup.object().shape({
  isRegisteredAgent: Yup.string().required('This field is required'),
  hasTwic: Yup.string().required('This field is required'),
  twicContractorsNumber: Yup.number().required('This field is required'),
  hasFast: Yup.string().required('This field is required'),
  fastContractorsNumber: Yup.number().required('This field is required'),
  hasSida: Yup.string().required('This field is required'),
  sidaContractorsNumber: Yup.number().required('This field is required'),
  hasHazmat: Yup.string().required('This field is required'),
  hazmatContractorsNumber: Yup.number().required('This field is required'),
})
